import React from 'react';
import useDocumentTitle from '../../useDocumentTitle'
import TestQuiz from '../quizcode/code_3ab'
import NavbarCheck from '../../navbarCheck';

export default function Quiz(quiz_number) {
  useDocumentTitle("101Check | FRC101 by the Spartbaots")
  return (
    <div>
      <NavbarCheck />
      <TestQuiz />
    </div>
  )
}